// Handles the redirect back from the server after Azure Entra ID authentication.
// The server passes the JWT and user details in the URL fragment (#token=...),
// never in query params, so it doesn't appear in server logs.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SsoCallbackPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    // Parse fragment — URLSearchParams works on the hash without the leading #
    const fragment = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(fragment);

    const token = params.get("token");
    const id    = params.get("id");
    const email = params.get("email");
    const name  = params.get("name");
    const role  = params.get("role");

    if (!token || !id) {
      setError("SSO sign-in failed — incomplete response from server.");
      return;
    }

    const user = { id, email, name, role, mustChangePassword: false };
    login(token, user);

    // Clear the fragment from history so the token isn't bookmarkable
    window.history.replaceState(null, "", window.location.pathname);

    navigate("/", { replace: true });
  }, [login, navigate]);

  if (error) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#070b14",
        color: "#fca5a5",
        flexDirection: "column",
        gap: 12,
        fontFamily: "system-ui, sans-serif",
        padding: 24,
        textAlign: "center",
      }}>
        <p style={{ fontSize: 15, margin: 0 }}>{error}</p>
        <a href="/login" style={{ color: "#60a5fa", fontSize: 13 }}>Back to sign in</a>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#070b14",
      color: "#94a3b8",
      fontFamily: "system-ui, sans-serif",
      fontSize: 14,
    }}>
      Completing sign-in…
    </div>
  );
}
